import React, { useEffect, useRef } from 'react';
import styles from './PrivacyContent.module.css';
import backIcon from "../icons/back_icn.png";

const PrivacyContent = ({ onBack }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;
      let scrollInterval;

      const startAutoScroll = () => {
        scrollInterval = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval);
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval);
        content.removeEventListener('wheel', stopAutoScroll);
        content.removeEventListener('touchstart', stopAutoScroll);
      };

      content.addEventListener('wheel', stopAutoScroll);
      content.addEventListener('touchstart', stopAutoScroll);

      return () => {
        content.removeEventListener('wheel', stopAutoScroll);
        content.removeEventListener('touchstart', stopAutoScroll);
        clearInterval(scrollInterval);
      };
    }
  }, []);

return (
  <div className={styles.legalContentContainer}>
    <div className={styles.legalContent} ref={contentRef}>
      <h1>Політика конфіденційності</h1>
      <p><strong>Дата набрання чинності:</strong> 30 квітня 2026 року</p>

      <h2>Вступ</h2>
      <p>
        У <strong>Cult Project</strong> (представляє — <strong>Діана Максименко</strong>, власниця/керуюча та відповідальна за прийом платежів) ми поважаємо вашу приватність і збираємо мінімально необхідні дані. Ця Політика пояснює, як ми обробляємо інформацію під час використання вами нашого цифрового сервісу з продажу електронних квитків на заходи.
      </p>
      <p>
        Розробник платформи — <strong>Олександр Трішкін (Quality Performance Core Ltd)</strong>.
      </p>
      <p>
        Ми не покладаємося на email чи інші прямі контактні дані. Аутентифікація здійснюється за допомогою безпечних ключових методів (passkeys тощо), які не потребують традиційних персональних даних.
      </p>

      <h2>Згода на обробку даних</h2>
      <p>
        Користуючись сервісом, ви прямо погоджуєтесь на обробку будь-яких даних, що передаються в нашу систему (включно з платіжною інформацією та зверненнями до підтримки), відповідно до цієї Політики.
      </p>

      <h2>Яку інформацію ми збираємо</h2>
      <p>
        <strong>Ідентифікатор користувача:</strong> для надання доступу до придбаних електронних квитків ми використовуємо унікальний технічний ідентифікатор (наприклад, ключ або credential ID). Це не ваше справжнє ім’я чи email, а мінімальний технічний маркер доступу.
      </p>
      <p>
        <strong>ПІБ на квитку:</strong> під час оформлення електронного квитка ми можемо попросити ваше повне ім’я виключно для відображення на квитку (PDF/електронний формат). Це ім’я використовується лише в тексті квитка і не застосовується повторно в інших цілях.
      </p>
      <p>
        <strong>Дані використання:</strong> ми можемо збирати неперсоніфіковану інформацію про те, які події переглядаються або відкриваються. Це допомагає нам розуміти продуктивність платформи та покращувати досвід користувачів.
      </p>
      <p>
        <strong>Стороннє вимірювання ефективності:</strong> ми не завантажуємо клієнтські (браузерні) пікселі. Продуктивність платформи вимірюється лише через серверні події, що надсилаються до Meta (Facebook) за допомогою Conversions API. Передані дані обмежуються назвою події, часовою міткою, IP-адресою та User-Agent. Трекінг TikTok і X (Twitter) наразі вимкнено; email, номер телефону та інші ідентифікатори не передаються.
      </p>
      <p>Ці дані використовуються у зведеному (агрегованому) вигляді і не пов’язуються з особою.</p>

      <h2>Cookies</h2>
      <p>
        Наш сайт не встановлює власних маркетингових cookies. Під час оплати через еквайринг <strong>monobank</strong> банк та/або його партнери можуть встановлювати суто технічні cookies, необхідні для завершення платежу та запобігання шахрайству. Ми не використовуємо ці cookies для аналітики чи реклами.
      </p>

      <h2>Службові повідомлення та підтримка</h2>
	<p>
	  Інформація про успішні оплати та статуси замовлень доставляється до вашого розділу
	  <em>Твій Простір → Повідомлення</em> за допомогою безпечних серверних повідомлень
	  (webhook/системні нотифікації). Ваш реальний email ми не збираємо та не використовуємо
	  для масових розсилок.
	</p>
	<p>
	  <strong>Прихований email-аліас.</strong> Під час реєстрації акаунта ми автоматично
	  створюємо унікальний прихований email-аліас, прив’язаний до вашого ID. Ми використовуємо
	  його виключно для: (1) отримання підтверджень успішних оплат від <strong>monobank</strong>
	  (через інтеграцію API/webhook), (2) отримання технічних оновлень/нотифікацій і відгуків
	  підтримки, та (3) автоматичного переадресування всіх повідомлень у ваш розділ
	  <em>Твій Простір → Повідомлення</em>. Ваш фактичний email на стороні сервісу не
	  зберігається і не використовується напряму.
	</p>

      <h2>Як ми використовуємо інформацію</h2>
      <p>
        <strong>Надання доступу:</strong> технічний ідентифікатор використовується для перевірки вашого права на перегляд/завантаження електронного квитка та керування входом на захід.
      </p>
      <p>
        <strong>Поліпшення сервісу:</strong> ми аналізуємо агреговані, неперсоніфіковані дані та серверні події, щоб підтримувати роботу платформи і вдосконалювати її.
      </p>
      <p>
        <strong>Маркетинг та аналітика:</strong> клієнтські пікселі не використовуються. Вимірювання здійснюється тільки через серверні події до Meta (Conversions API). Передача даних до TikTok і X (Twitter) не здійснюється.
      </p>
      <p>
        <strong>Мінімальна комунікація:</strong> оскільки ми не вимагаємо email чи інші прямі контакти, ми не надсилаємо масові промо-листи. Важливі оновлення публікуються в інтерфейсі платформи.
      </p>

      <h2>Обробка платежів</h2>
      <p>
        Усі платежі обробляються через платіжну систему <strong>monobank</strong> (еквайринг). Підтвердження платежів ми отримуємо через захищені серверні інтеграції (API/webhook) та відображаємо у вашому акаунті.
      </p>

      <h2>Розкриття інформації</h2>
      <p>
        Ми не продаємо, не здаємо в оренду і не обмінюємо персональні дані. Ми можемо передавати неперсоніфіковані дані та/або мінімально необхідні технічні відомості надійним постачальникам послуг (хостинг, доставка цифрового контенту) виключно для підтримки роботи платформи.
      </p>

      <h2>Безпека даних</h2>
      <p>
        Ми застосовуємо розумні технічні та організаційні заходи захисту. Оскільки ми не обробляємо чутливі дані на кшталт email чи платіжних реквізитів у себе, ризики зменшені.
      </p>

      <h2>Права суб’єктів даних</h2>
      <p>
        Ми не зберігаємо на сервері ваші біометричні дані (відбитки пальців, Face ID, Windows Hello тощо). На нашому боці зберігається лише публічний ключ (або credential ID), пов’язаний із вашим акаунтом; біометричні шаблони залишаються на вашому пристрої та використовуються лише для розблокування ключа. Якщо ви видалите облікові дані з пристрою, автентифікація стане неможливою.
      </p>
      <p>
        Щоб подати запит на видалення будь-яких даних — включно з електронними квитками, діалогами підтримки або всім акаунтом — увійдіть у систему та надішліть звернення через розділ <em>Твій Простір → Повідомлення</em>. Це дозволяє безпечно ідентифікувати ваш ID. Ми опрацюємо запит протягом одного тижня.
      </p>

      <h2>Зберігання даних</h2>
      <p>
        Ваші автентифікаційні облікові дані (публічні ключі) зберігаються, доки акаунт активний. Відомості про придбані електронні квитки зберігаються до завершення події та протягом періоду, необхідного для бухгалтерського обліку, вирішення спорів і виконання вимог законодавства, після чого можуть бути заархівовані або видалені.
      </p>

      <h2>Повідомлення про інциденти безпеки</h2>
      <p>
        У разі порушення безпеки персональних даних ми повідомимо постраждалих користувачів і, за необхідності, регуляторні органи протягом 72 годин із моменту виявлення інциденту згідно із застосовним законодавством.
      </p>

      <h2>Конфіденційність дітей</h2>
      <p>
        Наша платформа не призначена для осіб молодше 13 років. Ми свідомо не збираємо інформацію про дітей.
      </p>

      <h2>Зміни до цієї Політики</h2>
      <p>
        Ми можемо періодично оновлювати цю Політику. Актуальна версія публікується на цій сторінці з оновленою датою набрання чинності та діє з моменту публікації.
      </p>

      <h2>Відповідальна особа та контакти</h2>
      <p>
        Відповідальна за прийом платежів і проведення івентів: <strong>Діана Максименко</strong> (<strong>Cult Project</strong>).
      </p>
      <p>
        Зв’язок: <a href="mailto:cult@qpcore.com">cult@qpcore.com</a> або через розділ <em>Твій Простір → Повідомлення</em> у вашому акаунті.
      </p>
      <p>
        Технічні питання щодо платформи: розробник — <strong>Олександр Трішкін (Quality Performance Core Ltd)</strong> <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
	</div>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
    </div>
  );
};

export default PrivacyContent;
